// Mock data for EVERKAST NZ Paints & Specialty Coatings

export const categories = [
  {
    id: 'interior-paints',
    name: 'Interior Paints',
    slug: 'interior-paints',
    description: 'High-quality interior paints for residential and commercial spaces',
    image: '/images/categories/Interior-Paints.png'
  },
  {
    id: 'exterior-paints',
    name: 'Exterior Paints',
    slug: 'exterior-paints',
    description: 'Durable exterior paints designed to withstand New Zealand weather conditions',
    image: '/images/categories/Exterior-Paints.png'
  },
  {
    id: 'primers-base-layers',
    name: 'Primers & Base Layers',
    slug: 'primers-base-layers',
    description: 'Essential primers and base coatings for optimal paint adhesion and performance',
    image: '/images/categories/Primers-BaseLayers.png'
  },
  {
    id: 'specialty-finishes',
    name: 'Specialty Decorative Finishes',
    slug: 'specialty-finishes',
    description: 'Premium decorative finishes and specialty coatings for unique applications',
    image: '/images/categories/Specialty-Decorative-Finishes.png'
  }
];

export const products = [
  // Interior Paints
  {
    id: 'proflex-interior',
    name: 'Proflex',
    category: 'interior-paints',
    shortDescription: 'Acrylic paint for interior use',
    fullDescription: 'Proflex is an acrylic paint for interior use that stabilizes, protects, and decorates walls with vivid, stable colors.',
    properties: [
      'Excellent coverage',
      'Vivid and stable colors',
      'Easy application',
      'Low odor',
      'Quick drying'
    ],
    advantages: [
      'Long-lasting protection',
      'Decorates and stabilizes surfaces',
      'Professional finish',
      'Durable color retention',
      'Easy to clean'
    ],
    applications: [
      'Interior walls',
      'Ceilings',
      'Plaster',
      'Drywall',
      'Masonry'
    ],
    packages: '10L, 3L, 1L',
    sustainability: 'Water-based, environmentally friendly formulation',
    technicalSheet: '/downloads/proflex-datasheet.pdf',
    image: '/images/products/proflex.jpg'
  },
  {
    id: 'neotherm-ac',
    name: 'Neotherm AC',
    category: 'interior-paints',
    shortDescription: 'Anti-condensation paint',
    fullDescription: 'Anti-condensation paint designed to prevent water vapour condensation on internal walls and ceilings, preventing mould and bacteria growth.',
    properties: [
      'Prevents vapour condensation',
      'High water vapour permeability',
      'Low thermal conductivity',
      'Excellent washability',
      'High coverage'
    ],
    advantages: [
      'Prevents mould growth',
      'Ideal for high humidity areas',
      'Perfect for bathrooms and kitchens',
      'Easy application',
      'Professional finish'
    ],
    applications: [
      'Bathrooms',
      'Kitchens',
      'Wet rooms',
      'Internal walls',
      'Ceilings'
    ],
    packages: '10L, 3L, 1L',
    sustainability: 'Water-based, eco-friendly',
    technicalSheet: '/downloads/neotherm-ac-datasheet.pdf',
    image: '/images/products/neotherm-ac.jpg'
  },

  // Exterior Paints
  {
    id: 'proflex-exterior',
    name: 'Proflex',
    category: 'exterior-paints',
    shortDescription: 'Acrylic paint for exterior use',
    fullDescription: 'Proflex is an acrylic paint for exterior use that protects and decorates walls and facades. Offers excellent resistance to solar radiation and adverse weather.',
    properties: [
      'Excellent UV resistance',
      'Withstands harsh weather',
      'Vivid stable colors',
      'High coverage',
      'Easy application'
    ],
    advantages: [
      'Long-lasting protection',
      'Weather resistant',
      'Professional finish',
      'Durable color retention',
      'Easy maintenance'
    ],
    applications: [
      'Exterior walls',
      'Facades',
      'Concrete surfaces',
      'Render',
      'Masonry'
    ],
    packages: '10L, 3L, 1L',
    sustainability: 'Water-based, environmentally friendly',
    technicalSheet: '/downloads/proflex-datasheet.pdf',
    image: '/images/products/proflex.jpg'
  },
  {
    id: 'silatex-reflect',
    name: 'Silatex Reflect',
    category: 'exterior-paints',
    shortDescription: 'Reflective elastomeric coating',
    fullDescription: 'Certified reflective elastomeric coating for exterior walls providing waterproofing, thermal insulation, and high solar reflectance.',
    properties: [
      'High solar reflectance',
      'Thermal emittance',
      'Elastomeric crack-bridging',
      'Maintains whiteness',
      'Dirt resistant'
    ],
    advantages: [
      'Reduces surface temperatures',
      'Energy saving',
      'Weather resistant',
      'Long-term protection',
      'Professional finish'
    ],
    applications: [
      'Exterior walls',
      'Building facades',
      'Commercial buildings',
      'Residential exteriors',
      'Thermal systems'
    ],
    packages: '10L, 3L, 1L',
    sustainability: 'Reflective technology, energy efficient',
    technicalSheet: '/downloads/silatex-reflect-datasheet.pdf',
    image: '/images/products/silatex-reflect.jpg'
  },
  {
    id: 'revinex-elastic',
    name: 'Revinex Elastic',
    category: 'exterior-paints',
    shortDescription: 'Elastomeric waterproofing paint',
    fullDescription: 'Elastomeric paint for external vertical surfaces, providing absolute protection from moisture with a matte finish.',
    properties: [
      'Exceptional adhesion',
      'Water impermeability',
      'High elasticity',
      'Dust resistant',
      'Non-tacky'
    ],
    advantages: [
      'Long-lasting coating',
      'Flexible crack-bridging',
      'UV resistant',
      'Professional matte finish',
      'Weather resistant'
    ],
    applications: [
      'Exterior walls',
      'Facades',
      'Concrete',
      'Render',
      'Masonry'
    ],
    packages: '10L, 3L, 1L',
    sustainability: 'Water-based, silane-modified',
    technicalSheet: '/downloads/revinex-elastic-datasheet.pdf',
    image: '/images/products/revinex-elastic.jpg'
  },

  // Primers & Base Layers
  {
    id: 'acqua-primer',
    name: 'Acqua Primer',
    category: 'primers-base-layers',
    shortDescription: 'Water-based epoxy primer',
    fullDescription: 'Two-component water-based epoxy primer with ultra-low VOC emissions for substrate preparation.',
    properties: [
      'Ultra-low VOC',
      'Excellent adhesion',
      'Fast drying',
      'Easy application',
      'Versatile substrate compatibility'
    ],
    advantages: [
      'Perfect substrate preparation',
      'Water-based formula',
      'Professional grade',
      'Quick application',
      'Low odor'
    ],
    applications: [
      'Concrete surfaces',
      'Cementitious substrates',
      'Before coatings',
      'Floor preparation',
      'Wall preparation'
    ],
    packages: '10kg, 2.5kg (A+B sets)',
    sustainability: 'Water-based, ultra-low VOC',
    technicalSheet: '/downloads/acqua-primer-datasheet.pdf',
    image: '/images/products/acqua-primer.jpg'
  },
  {
    id: 'revinex-primer',
    name: 'Revinex',
    category: 'primers-base-layers',
    shortDescription: 'Universal primer',
    fullDescription: 'Universal water-based primer for preparing surfaces before coating applications.',
    properties: [
      'Universal application',
      'Water-based',
      'Fast drying',
      'Good penetration',
      'Excellent adhesion'
    ],
    advantages: [
      'Versatile use',
      'Easy application',
      'Improves adhesion',
      'Cost-effective',
      'Professional results'
    ],
    applications: [
      'Concrete',
      'Masonry',
      'Plaster',
      'Cementitious surfaces',
      'Before paint application'
    ],
    packages: '10L, 3L',
    sustainability: 'Water-based, low VOC',
    technicalSheet: '/downloads/revinex-primer-datasheet.pdf',
    image: '/images/products/revinex-primer.jpg'
  },
  {
    id: 'neotex-inox-primer',
    name: 'Neotex Inox Primer',
    category: 'primers-base-layers',
    shortDescription: 'Anti-corrosive primer',
    fullDescription: 'Specialized anti-corrosive primer for metal surfaces and demanding applications.',
    properties: [
      'Anti-corrosive protection',
      'Excellent adhesion',
      'Fast drying',
      'Rust prevention',
      'Professional grade'
    ],
    advantages: [
      'Long-term metal protection',
      'Easy application',
      'Durable coating',
      'Weather resistant',
      'Professional finish'
    ],
    applications: [
      'Metal surfaces',
      'Steel structures',
      'Iron work',
      'Industrial applications',
      'Exterior metalwork'
    ],
    packages: '5L, 1L',
    sustainability: 'Protective coating for extended surface life',
    technicalSheet: '/downloads/neotex-inox-primer-datasheet.pdf',
    image: '/images/products/neotex-inox-primer.jpg'
  },

  // Specialty Decorative Finishes
  {
    id: 'neodur-varnish-w-mat',
    name: 'Neodur Varnish W Mat',
    category: 'specialty-finishes',
    shortDescription: 'Water-based polyurethane varnish with matte finish',
    fullDescription: 'Transparent water-based polyurethane varnish with a matte finish, providing high durability and excellent protection for various surfaces.',
    properties: [
      'UV resistant',
      'High hardness',
      'Chemical resistant',
      'Mechanical resistance',
      'Low VOC emissions'
    ],
    advantages: [
      'Professional matte appearance',
      'Easy maintenance',
      'Long-lasting protection',
      'Water-based formula',
      'Quick application'
    ],
    applications: [
      'Interior concrete floors',
      'Decorative surfaces',
      'Industrial flooring',
      'Commercial spaces',
      'Residential floors'
    ],
    packages: '3kg, 0.8kg',
    sustainability: 'Water-based, ultra-low VOC',
    technicalSheet: '/downloads/neodur-varnish-w-mat-datasheet.pdf',
    image: '/images/products/neodur-varnish-mat.jpg'
  },
  {
    id: 'neodur-varnish-w-satin',
    name: 'Neodur Varnish W Satin',
    category: 'specialty-finishes',
    shortDescription: 'Water-based polyurethane varnish with satin finish',
    fullDescription: 'Transparent water-based polyurethane varnish with a satin finish, offering excellent durability and enhanced anti-slip properties.',
    properties: [
      'UV resistant (non-yellowing)',
      'High chemical resistance',
      'Excellent abrasion resistance',
      'Strong adhesion',
      'Anti-slip properties'
    ],
    advantages: [
      'Protection against water absorption',
      'Stain and discoloration resistant',
      'Weathering protection',
      'Solvent-free, low VOC',
      'Easy to apply'
    ],
    applications: [
      'Microcement',
      'Concrete floors',
      'Resin floors',
      'Decorative cement screed',
      'Metallic surfaces'
    ],
    packages: '3kg, 0.8kg',
    sustainability: 'Water-based, ultra-low VOC (<1 g/L)',
    technicalSheet: '/downloads/neodur-varnish-w-satin-datasheet.pdf',
    image: '/images/products/neodur-varnish-satin.jpg'
  },
  {
    id: 'neodur-varnish-w-gloss',
    name: 'Neodur Varnish W Gloss',
    category: 'specialty-finishes',
    shortDescription: 'Water-based polyurethane varnish with gloss finish',
    fullDescription: 'Transparent water-based polyurethane varnish with a high-gloss finish, providing superior protection and aesthetic appeal.',
    properties: [
      'High-gloss finish',
      'UV resistant',
      'Excellent abrasion resistance',
      'Chemical resistant',
      'Superior adhesion'
    ],
    advantages: [
      'Professional glossy appearance',
      'Enhanced surface protection',
      'Easy to clean',
      'Durable coating',
      'Low maintenance'
    ],
    applications: [
      'Concrete floors',
      'Decorative coatings',
      'Industrial applications',
      'Showrooms',
      'Commercial spaces'
    ],
    packages: '3kg, 0.8kg',
    sustainability: 'Water-based, low VOC formula',
    technicalSheet: '/downloads/neodur-varnish-w-gloss-datasheet.pdf',
    image: '/images/products/neodur-varnish-gloss.jpg'
  },
  {
    id: 'neocryl-sport-flex',
    name: 'Neocryl Sport Flex',
    category: 'specialty-finishes',
    shortDescription: 'Anti-slip sports surface coating',
    fullDescription: 'Anti-slip acrylic coating designed for sports surfaces like tennis and basketball courts.',
    properties: [
      'High weather resistance',
      'Excellent abrasion resistance',
      'Anti-slip properties',
      'Strong adhesion',
      'Flexibility'
    ],
    advantages: [
      'Extends surface life',
      'Easy application',
      'Low VOC',
      'CE certified',
      'Durable finish'
    ],
    applications: [
      'Tennis courts',
      'Basketball courts',
      'Volleyball courts',
      'Schoolyards',
      'Playgrounds'
    ],
    packages: '12kg',
    sustainability: 'Low VOC, CE certified',
    technicalSheet: '/downloads/neocryl-sport-flex-datasheet.pdf',
    image: '/images/products/neocryl-sport-flex.jpg'
  },
  {
    id: 'neopox-w-plus',
    name: 'Neopox W Plus',
    category: 'specialty-finishes',
    shortDescription: 'Water-based epoxy coating',
    fullDescription: 'Premium water-based epoxy coating with ultra-low VOC emissions, suitable for floors and walls.',
    properties: [
      'Ultra-low VOC',
      'Excellent durability',
      'High wet-scrub resistance',
      'Fire-rated',
      'Odorless'
    ],
    advantages: [
      'Zero-VOC formula',
      'Excellent mechanical resistance',
      'Chemical resistant',
      'Easy to clean',
      'Professional finish'
    ],
    applications: [
      'Indoor floors',
      'Walls',
      'Production facilities',
      'Warehouses',
      'High-humidity areas'
    ],
    packages: '12.5kg, 5kg, 1.25kg (A+B sets)',
    sustainability: 'Water-based, zero-VOC, A+ emission class',
    technicalSheet: '/downloads/neopox-w-plus-datasheet.pdf',
    image: '/images/products/neopox-w-plus.jpg'
  }
];

export const companyInfo = {
  name: 'EVERKAST NZ Limited',
  tagline: 'Premium Decorative & Protective Paints',
  subTagline: 'High-quality paints for interior, exterior, and specialised surfaces',
  description: 'Delivering durability, premium finish, and long-term protection for residential and commercial projects.',
  benefits: [
    {
      title: 'High Durability',
      description: 'Long-lasting protection and performance in demanding environments',
      icon: 'Shield'
    },
    {
      title: 'Excellent Adhesion',
      description: 'Superior bonding to various substrates for reliable application',
      icon: 'Layers'
    },
    {
      title: 'UV Resistance',
      description: 'Protection against sun damage with non-yellowing formulations',
      icon: 'Zap'
    },
    {
      title: 'Professional Finish',
      description: 'Quality coatings that deliver exceptional aesthetic results',
      icon: 'Check'
    }
  ],
  contact: {
    email: 'info@everkast.co.nz',
    phone: '+64 20 447 3518',
    address: 'Wellington, New Zealand'
  },
  about: {
    intro: 'Everkast NZ Limited is a New Zealand supplier of premium decorative paints and specialty coatings for residential, commercial, and selected specialty projects.',
    mission: 'To supply high-quality decorative and protective paint systems that deliver strong visual appeal, dependable durability, and reliable performance for modern homes, renovation projects, and commercial spaces across New Zealand.',
    range: 'Our product range includes decorative paints, finishes, protective coatings, and specialty primers designed for walls, facades, feature surfaces, and modern interior and exterior applications.',
    quality: 'We focus on proven, high-performance paint systems that meet the demands of today\'s building and renovation projects. Our products are selected for their durability, finish quality, and long-term performance.',
    closing: 'At Everkast NZ, we are committed to delivering reliable products and straightforward solutions that professionals can trust.'
  }
};
